import { render } from "./NewsmeigaraTrend.vue?vue&type=template&id=fbb898fa&scoped=true"
import script from "./NewsmeigaraTrend.vue?vue&type=script&lang=js"
export * from "./NewsmeigaraTrend.vue?vue&type=script&lang=js"

import "./NewsmeigaraTrend.vue?vue&type=style&index=0&id=fbb898fa&scoped=true&lang=css"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbb898fa"]])

export default __exports__